import React from "react";
import { Container } from "@mui/material";
import { makeStyles } from "@mui/styles";
import Page from "src/components/Page";
import SearchIndexingForm from "./SearchIndexingForm";

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: "100%",
    paddingTop: theme.spacing(3),
    paddingBottom: 100,
  },
}));

function SearchIndexing() {
  const classes = useStyles();

  return (
    <Page className={classes.root} title="Search Indexing">
      <Container maxWidth={false}>
        <SearchIndexingForm />
      </Container>
    </Page>
  );
}

export default SearchIndexing;